import { createSelector } from '@reduxjs/toolkit';
import { ProductEntity, ProductId } from '../types';
import {
  RecommendationProductsStoreState,
  RecommendationProductWithAnalytics
} from './types';

type RecommendationProductsSelectors = {
  selectRecommendationProducts: (
    state: RecommendationProductsStoreState,
    productId: ProductId
  ) => ProductId[] | [];
  selectRecommendationProductsAnalitics: (
    state: RecommendationProductsStoreState
  ) => ProductEntity<RecommendationProductWithAnalytics>;
  selectRecommendationProduct: (
    state: RecommendationProductsStoreState,
    productId: ProductId
  ) => RecommendationProductWithAnalytics | null;
};

const selectRecommendationProducts = createSelector(
  (
    state: RecommendationProductsStoreState,
    productId: ProductId
  ) => state.productsBond[productId],
  (productsBond) => productsBond || []
);

export default {
  selectRecommendationProducts,

  selectRecommendationProductsAnalitics: (state) =>
    state.entities,

  selectRecommendationProduct: (state, productId) =>
    state.entities?.[productId] || null
} as RecommendationProductsSelectors;
